var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Row",
    { attrs: { cols: 4, customClass: "stats-row" } },
    [
      _c("BackupsStatCard", { attrs: { id: _vm.id } }),
      _vm._v(" "),
      _c("DeploymentsStatCard", { attrs: { id: _vm.id } }),
      _vm._v(" "),
      _c("CostsStatCard", { attrs: { id: _vm.id } }),
      _vm._v(" "),
      _c("AlertsStatCard", { attrs: { id: _vm.id } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-767fb695", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-767fb695","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CardFormatting/StatsRow.vue
// module id = null
// module chunks = 